import moduleProjects from './project';

export default {
  namespaced: true,
  modules: {
    projects: moduleProjects,
  },
};
